import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const LabelGroup = styled.div`
  color: #14171f;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ValidationInput = styled.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
`
